import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { VideoBackgroundComponent } from 'src/app/shared/ui-common/video-background/video-background.component';
import { ButtonComponent } from 'src/app/shared/ui-common/button/button.component';
import { Router } from '@angular/router';

@Component({
  selector: 'app-feature-not-found',
  imports: [CommonModule, VideoBackgroundComponent, ButtonComponent],
  templateUrl: './feature-not-found.component.html',
  styleUrl: './feature-not-found.component.scss',
})
export class FeatureNotFoundComponent {

  constructor(private router: Router) {}

  onNavigateHome(): void {
    this.router.navigate(['/login']);
  }
}
